import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { getFeaturedLawyers } from '../../util/api';
import { storableError } from '../../util/errors';

export const ASSET_NAME = 'landing-page';

// ===================== Action Types =====================

const FETCH_FEATURED_LAWYERS_REQUEST = 'app/LandingPage/FETCH_FEATURED_LAWYERS_REQUEST';
const FETCH_FEATURED_LAWYERS_SUCCESS = 'app/LandingPage/FETCH_FEATURED_LAWYERS_SUCCESS';
const FETCH_FEATURED_LAWYERS_ERROR = 'app/LandingPage/FETCH_FEATURED_LAWYERS_ERROR';

// ===================== Reducer =====================

const initialState = {
  featuredLawyers: [],
  fetchFeaturedLawyersInProgress: false,
  fetchFeaturedLawyersError: null,
};

export default function landingPageReducer(state = initialState, action = {}) {
  const { type, payload, error } = action;
  switch (type) {
    case FETCH_FEATURED_LAWYERS_REQUEST:
      return { ...state, fetchFeaturedLawyersInProgress: true, fetchFeaturedLawyersError: null };
    case FETCH_FEATURED_LAWYERS_SUCCESS:
      return { ...state, fetchFeaturedLawyersInProgress: false, featuredLawyers: payload };
    case FETCH_FEATURED_LAWYERS_ERROR:
      return { ...state, fetchFeaturedLawyersInProgress: false, fetchFeaturedLawyersError: error ? payload : null };
    default:
      return state;
  }
}

// ===================== Action Creators =====================

const fetchFeaturedLawyersRequest = () => ({ type: FETCH_FEATURED_LAWYERS_REQUEST });
const fetchFeaturedLawyersSuccess = lawyers => ({ type: FETCH_FEATURED_LAWYERS_SUCCESS, payload: lawyers });
const fetchFeaturedLawyersError = e => ({ type: FETCH_FEATURED_LAWYERS_ERROR, error: true, payload: e });

// ===================== Thunks =====================

export const fetchFeaturedLawyers = () => dispatch => {
  dispatch(fetchFeaturedLawyersRequest());
  return getFeaturedLawyers({})
    .then(response => {
      const lawyers = response?.lawyers || [];
      dispatch(fetchFeaturedLawyersSuccess(lawyers));
      return lawyers;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(fetchFeaturedLawyersError(error));
    });
};

export const loadData = () => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
